import "bootstrap/dist/css/bootstrap.min.css";
import {
  Clock,
  FileText,
  Home,
  LogOut,
  MessageSquare,
  ShoppingBag,
  Users,
  X,
} from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/sidebar.css";
import { useNavigate } from "react-router-dom";

export default function Sidebar({ isOpen, onClose }) {
  const [activeItem, setActiveItem] = useState("/order/stats");
  const navigate = useNavigate();
  const items = [
    { icon: <Home />, label: "Tableau de bord", link: "/order/stats" },
    {
      icon: <FileText />,
      label: "Gestion des articles",
      link: "/admin-articles",
    },
    { icon: <Users />, label: "Gestion des Utilisateurs", link: "/admin-user" },
    { icon: <ShoppingBag />, label: "Commandes", link: "/order" },
    { icon: <Clock />, label: "Actualites", link: "/actualite" },
    { icon: <MessageSquare />, label: "Suggestion", link: "/messages" },
  ];

  const logout = () => {
    localStorage.clear();
    navigate("/");
  };
  return (
    <>
      {/* Overlay mobile */}
      {isOpen && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-lg-none sidebar-overlay"
          onClick={onClose}
          style={{ zIndex: 1040 }}
        />
      )}

      {/* Sidebar */}
      <div
        className="position-fixed bottom-0 start-0 d-flex flex-column text-white "
        style={{
          width: "16rem",
          height: "calc(100vh - 14vh)", // Hauteur totale - hauteur du header
          //top: "80px", // ← Commence juste sous le header
          transform: isOpen ? "translateX(0)" : "translateX(-100%)",
          transition: "transform 0.3s ease",
          zIndex: 1050,
          backgroundColor: "#303033",
          borderRadius: "0 20px 20px 0",
          overflowY: "auto",
        }}
      >
        {/* Header Sidebar */}
        <div className="p-3 border-bottom border-secondary d-flex justify-content-end">
          <button
            onClick={onClose}
            className="d-lg-none btn btn-link text-white p-2"
            aria-label="Close menu"
          >
            <X size={24} />
          </button>
        </div>

        {/* Navigation */}
        <nav
          className="flex-grow-1 p-3 d-flex flex-column gap-4 overflow-auto"
          // style={{ marginTop: "40%" }}
        >
          {items.map((item) => (
            <SidebarItem
              key={item.link}
              icon={item.icon}
              label={item.label}
              link={item.link}
              active={activeItem === item.link}
              onClick={() => {
                setActiveItem(item.link);
                if (window.innerWidth < 992) onClose();
              }}
            />
          ))}
        </nav>

        {/* Logout */}
        <div className="p-3 border-top border-secondary">
          <button
            className="d-flex align-items-center gap-2 text-white-80 btn btn-link text-decoration-none w-100 rounded p-2 hover-bg-gray-800"
            onClick={() => {
              logout();
            }}
          >
            <LogOut size={20} />
            <span>Se déconnecter</span>
          </button>
        </div>
      </div>
    </>
  );
}

function SidebarItem({ icon, label, active, link, onClick }) {
  return (
    <Link
      to={link}
      onClick={onClick}
      className={`d-flex align-items-center gap-2 p-2 rounded text-decoration-none transition-all ${
        active
          ? "bg-primary text-white"
          : "text-white-80 hover-bg-gray-800 hover-text-white"
      }`}
    >
      <span style={{ width: "1.25rem", height: "1.25rem" }}>{icon}</span>
      <span>{label}</span>
    </Link>
  );
}
